import { useSettingLoggedOutHomepageNewTopBannerCopy } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageNewTopBannerCopy";
import { useRandomNumber } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/TopHeaderBanner/__internal__/RandomNumbeContext";
import {
  StrictLocalizeFunction,
  useStrictLocalization,
} from "@faire/web--source/common/localization";
import { ResponsiveValues } from "@faire/web--source/slate/Theme/ResponsiveValues";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import isChromatic from "chromatic/isChromatic";
import { useMemo } from "react";

const UK_VARIANTS = (
  strictLocalize: StrictLocalizeFunction
): Array<{
  backgroundColor: string;
  responsiveImage: ResponsiveValues<IImage>;
  name: string;
  location: string;
  variantId: string;
}> => [
  {
    variantId: "top_header_banner_luna_curious",
    backgroundColor: "#5B2A25",
    responsiveImage: {
      mobileAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/a502311f9d8468ada297957a2f5604d0c5da556762b23d28f5de3cbd2e30c96e.jpeg",
      }),
      tabletAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/7934717d86f5f90e4bb6d283b335a4513dd72c52088b1cae3a6dd15d5e219267.jpeg",
      }),
      desktopAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/721739bee90de1cb06ae4981b44607bdf7b5a5e006fff846b9b5cfbb18f3acc6.jpeg",
      }),
      xLargeAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/889e6d1ebe679759d9658886b8d48cbfec850c4600675cb469c92f85c2a2d102.jpeg",
      }),
      xxLargeDesktop: IImage.build({
        url: "https://cdn.faire.com/fastly/92918d4ea40c5392d74933f2d465e48d766f2a251fd3733edb7e742c698eab24.jpeg",
      }),
    },
    name: strictLocalize({
      defaultMessage:
        "Kaoru Parry, Polly George, and Rheanna Lingham, Co-Owners of Luna & Curious",
      description: {
        text: "Logged out home page top header banner brand name",
        img: "https://cdn.faire.com/fastly/a3ce28462401bc91ac6d37192d50c2a0aaa91bdda2550a89b2dfe36552c5d721.png",
      },
    }),
    location: strictLocalize({
      defaultMessage: "London, UK",
      description: {
        text: "Logged out home page top header banner brand location",
        img: "https://cdn.faire.com/fastly/a3ce28462401bc91ac6d37192d50c2a0aaa91bdda2550a89b2dfe36552c5d721.png",
      },
    }),
  },
  {
    variantId: "top_header_banner_etc_store",
    backgroundColor: "#595604",
    responsiveImage: {
      mobileAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/301f8e3992d5827dae9f72afaebf7d3b6d4768d9806056eb89732aaa5a9e4f51.jpeg",
      }),
      tabletAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/c67e76091a4c785e09cc767109e7ed0f76683807c642bce1cac06f60dccb18f8.jpeg",
      }),
      desktopAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/31193a0ba0fe5cf5fe771fce69a3594c7a4479e43a0ae0732da80be2859c9aa9.jpeg",
      }),
      xLargeAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/460b9a9818077487b6c04a170f2f8b426f47496ebfc7decabf097058a2450c0a.jpeg",
      }),
      xxLargeDesktop: IImage.build({
        url: "https://cdn.faire.com/fastly/0616b4ff5e25a2e720fbf33dc75f526d5c6121cc256f746ff1e4905e591af0c6.jpeg",
      }),
    },
    name: strictLocalize({
      defaultMessage: "Jana Starcevic, Co-Founder of Etc. Store",
      description: {
        text: "Logged out home page top header banner brand name",
        img: "https://cdn.faire.com/fastly/8263501218aed3c4f67f1b78b848db6bed4e3d56d38afae0080006ad5808d48e.png",
      },
    }),
    location: strictLocalize({
      defaultMessage: "London, UK",
      description: {
        text: "Logged out home page top header banner brand location",
        img: "https://cdn.faire.com/fastly/8263501218aed3c4f67f1b78b848db6bed4e3d56d38afae0080006ad5808d48e.png",
      },
    }),
  },
  {
    variantId: "top_header_banner_earl_of_east",
    backgroundColor: "#5B2A25",
    responsiveImage: {
      mobileAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/e471a0fbd199c4fc19de1107612649f5a2d1aab2ce46bbdaf2926345cc482956.jpeg",
      }),
      tabletAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/e10c6acac24ed689417aedbe4933338c2d20c15f3f7322afbb52f0eff6810ca0.jpeg",
      }),
      desktopAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/edac9140895184359cb99da22a9cb8d5268aab5f2bc2ba50048cc7f578e84874.jpeg",
      }),
      xLargeAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/f6e3cee66e3140d145a1f31c5a210955a2caf747da44d9d8270a5393970e80f4.jpeg",
      }),
      xxLargeDesktop: IImage.build({
        url: "https://cdn.faire.com/fastly/1a3d5a75786807b3de006898daa427d2c47d4fdcc52112ca2905656230f771e4.jpeg",
      }),
    },
    name: strictLocalize({
      defaultMessage:
        "Paul Firmin and Niko Dafkos, Co-Founders of Earl of East",
      description: {
        text: "Logged out home page top header banner brand name",
        img: "https://cdn.faire.com/fastly/c5a491df86ac87de203e90917a2a08da3cae8a45c4cdd6db1c72c4ec531e465e.png",
      },
    }),
    location: strictLocalize({
      defaultMessage: "London, UK",
      description: {
        text: "Logged out home page top header banner brand location",
        img: "https://cdn.faire.com/fastly/c5a491df86ac87de203e90917a2a08da3cae8a45c4cdd6db1c72c4ec531e465e.png",
      },
    }),
  },
];

const VARIANTS = (
  strictLocalize: StrictLocalizeFunction
): Array<{
  backgroundColor: string;
  responsiveImage: ResponsiveValues<IImage>;
  name: string;
  location: string;
  variantId: string;
}> => [
  {
    variantId: "top_header_banner_ab_fits",
    backgroundColor: "#595604",
    responsiveImage: {
      mobileAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/c9861e66ce1674b3e79289c73ac230eeb7ba319bb83ea36438fedbb554694752.jpeg",
      }),
      tabletAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/4d46c47ec3445e6ef64ca80928ad097dc7660fa4ebbc948be79ad4df3f1b68d3.jpeg",
      }),
      desktopAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/9693b72e7fb0d90d0fe6dbeb0dc27ad0ecf34522c7606a0b7b3e4b025c64f598.jpeg",
      }),
      xLargeAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/8d901714d5585625b7bff13cff16ec48c8841f0eb4880b867a31f6219e15d22e.jpeg",
      }),
      xxLargeDesktop: IImage.build({
        url: "https://cdn.faire.com/fastly/0531ddbee3356e1d540c850ccffe629baf97ca90bd161c42bf49dd2a19984292.jpeg",
      }),
    },
    name: strictLocalize({
      defaultMessage: "Howard Gee, Founder of AB Fits",
      description: {
        text: "Logged out home page top header banner brand name",
        img: "https://cdn.faire.com/fastly/f250bdd03aa1a067b881f8e6b0cec55b26892f2141161393ac993eecc5c81043.png",
      },
    }),
    location: strictLocalize({
      defaultMessage: "San Francisco, California",
      description: {
        text: "Logged out home page top header banner brand location",
        img: "https://cdn.faire.com/fastly/f250bdd03aa1a067b881f8e6b0cec55b26892f2141161393ac993eecc5c81043.png",
      },
    }),
  },
  {
    variantId: "top_header_banner_festival_collective",
    backgroundColor: "#5B2A25",
    responsiveImage: {
      mobileAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/90789092c0638bb68f512c1cc0b0547535392807068c749e20aaab79b6ca3881.jpeg",
      }),
      tabletAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/0157bd84149bc07a0b1dba7303b8db7c0ee21c98ddf739bac6fcd26a669fe89a.jpeg",
      }),
      desktopAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/8a4e7e5bee219e1398295206ea5e4e847bdd9a4becff00438e438f32b1601001.jpeg",
      }),
      xLargeAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/967c59f7cb84e57c24eb9a9217da9a44e9c4e26396cb963942cd9d537b52aa62.jpeg",
      }),
      xxLargeDesktop: IImage.build({
        url: "https://cdn.faire.com/fastly/3fbd32d901d1db43be40ff725fb778cd4c2f3d0baadb9b1a52ded8476b77f7b1.jpeg",
      }),
    },
    name: strictLocalize({
      defaultMessage: "Angela Wator, Founder of Festive Collective",
      description: {
        text: "Logged out home page top header banner brand name",
        img: "https://cdn.faire.com/fastly/59b7c648ccf6b568df29f77203826ee5419de606c2e9704c370a22c1f151cdf6.png",
      },
    }),
    location: strictLocalize({
      defaultMessage: "Chicago, Illinois",
      description: {
        text: "Logged out home page top header banner brand location",
        img: "https://cdn.faire.com/fastly/59b7c648ccf6b568df29f77203826ee5419de606c2e9704c370a22c1f151cdf6.png",
      },
    }),
  },
  {
    variantId: "top_header_banner_post_script",
    backgroundColor: "#083114",
    responsiveImage: {
      mobileAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/ce353a151b005e7fdd9b4fd540a35ba3eb388a160b127f01daa8b5eb3d654944.jpeg",
      }),
      tabletAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/c11c84f8e24f938b16d4f45bba1743ed33868a0b057d89e37ebe196c98b7445c.jpeg",
      }),
      desktopAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/a65367e39779bc20a9b0749e1904e836800c86da2c6028635a9ff3435f7a662d.jpeg",
      }),
      xLargeAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/18ca78ee2f31c0b68b017a218b259af2e0e00a21e1f23ea0314eba03d1e99c9e.jpeg",
      }),
      xxLargeDesktop: IImage.build({
        url: "https://cdn.faire.com/fastly/e4cda4cb5ce4dc800ebc752e074be7617acb72d36b11bb5d705c01452620c618.jpeg",
      }),
    },
    name: strictLocalize({
      defaultMessage: "Chandler Tang, Founder of post.script.",
      description: {
        text: "Logged out home page top header banner brand name",
        img: "https://cdn.faire.com/fastly/a4c058f184b482412d2150c574dc716e159ab03aaaf22dabeebd08d7a2217aa4.png",
      },
    }),
    location: strictLocalize({
      defaultMessage: "San Francisco, California",
      description: {
        text: "Logged out home page top header banner brand location",
        img: "https://cdn.faire.com/fastly/a162fd94a1a7d0b3c6caa315af71add26e244b522c049540f801ff4bf4980b7a.png",
      },
    }),
  },
  {
    variantId: "top_header_banner_merci_milo",
    backgroundColor: "#083114",
    responsiveImage: {
      mobileAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/6f174ccfd78008a0bf37fe8a7af31a8bf6a430b52f6acf75eef426258816441c.jpeg",
      }),
      tabletAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/c633beb8ee71ee77b1efd45eea1c3deb41c86f8556d955dc46b3d4f8149115e7.jpeg",
      }),
      desktopAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/29f03571d6a0125c980b92a4db9b9112f9bd9877a81bea3e9573a78b70367c93.jpeg",
      }),
      xLargeAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/fb9c0ad9f2df25cf72be31a09f31f04d48ef6aaa818eea56d12d2f4072596c04.jpeg",
      }),
      xxLargeDesktop: IImage.build({
        url: "https://cdn.faire.com/fastly/952aa13b7aa36e39a06e82f70d67d8843748e4311278844b6c0bfae359a24469.jpeg",
      }),
    },
    name: strictLocalize({
      defaultMessage: "Caroline Kim-Rodrigues, Founder of Merci Milo",
      description: {
        text: "Logged out home page top header banner brand name",
        img: "https://cdn.faire.com/fastly/dd4eaf6c3ce9819e1d22142deec150fafa7ed6e44cf4b655aa66811627ef97d0.png",
      },
    }),
    location: strictLocalize({
      defaultMessage: "Los Angeles, California and Portland, Oregon",
      description: {
        text: "Logged out home page top header banner brand location",
        img: "https://cdn.faire.com/fastly/888a798a181afe02fc32c633899cab4dfa93a0ded173eac064b9cf29591f8c90.png",
      },
    }),
  },
];

export const useGetTopHeaderBannerVariant = ({
  showLocalizedContent,
}: {
  showLocalizedContent: boolean;
}) => {
  const { strictLocalize } = useStrictLocalization();
  const randomNumber = useRandomNumber();

  const variant = useMemo(() => {
    if (isChromatic()) {
      return VARIANTS(strictLocalize)[0];
    }
    const bannerVariants = showLocalizedContent
      ? UK_VARIANTS(strictLocalize)
      : VARIANTS(strictLocalize);

    const variantNumber = Math.floor(randomNumber * bannerVariants.length);
    return bannerVariants[variantNumber];
  }, [strictLocalize, randomNumber, showLocalizedContent]);

  return variant;
};

export const useTopHeaderBannerText = () => {
  const { strictLocalize } = useStrictLocalization();
  const homepageTopBannerCopyVariant =
    useSettingLoggedOutHomepageNewTopBannerCopy();
  switch (homepageTopBannerCopyVariant) {
    case IThreeVariantXP.Bucket.VARIANT_2:
      return strictLocalize({
        defaultMessage: "Buy for your store, all in one place.",
        description: {
          text: "Logged out home page top header banner title",
          img: "https://cdn.faire.com/fastly/54e0e88c5c4b251800ea1ede6fac48184dc7b10aafc777383375cc3d89780ed1.png",
        },
      });
    case IThreeVariantXP.Bucket.VARIANT_3:
      return strictLocalize({
        defaultMessage: "Buy on Faire, a market for retailers.",
        description: {
          text: "Logged out home page top header banner title",
          img: "https://cdn.faire.com/fastly/274e5f99ebb5705b343506c18fc36ec85b56f6415b9ed2eb13d7b0d135d4e4f1.png",
        },
      });
    default:
      return strictLocalize({
        defaultMessage: "Buy products for your store your customers will love.",
        description: {
          text: "Logged out home page top header banner title",
          img: "https://cdn.faire.com/fastly/198b7327d7b3b1bf10c635114a0a85954d5953837928efd1b95c27857aec4a6d.png",
        },
      });
  }
};
